import React from "react"
import {FieldAutomationActionFormProps} from "../../../../render/automation-action-form";
import SelectGenericNew from "../../../../../gd-ui/select-generic-new/select-generic-new";



const debug = false
// const debug = "DateActionForm"


export default class FieldToDoListTemplate_AutomationActionForm extends React.Component<FieldAutomationActionFormProps,any> {

    constructor(props:FieldAutomationActionFormProps) {
        super(props)

        this.state = {
            toValue: _.get(props.config, 'toValue', null)
        }
    }

    onChangeToValue = (option:any) => {
        const toValue = option ? option.value : null

        this.setState({
            toValue
        }, ()=>{
            this.props.onChangeCallback({toValue})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        const labelClasses = Classes("label","w-100")

        return (
            <div className="flex-row-left-top">
                <div className={labelClasses}>To-do list: </div>
                <SelectGenericNew className                     = "selector w-180"
                                  options                       = {this.props.field.getAutomationOptions()}
                                  value                         = {this.state.toValue}
                                  popoverScrollContainerClasses = "max-h-200"
                                  noValueOption                 = {true}
                                  isSearchable                  = {true}
                                  disabled                      = {this.props.config.disabled}
                                  onChange                      = {this.onChangeToValue}/>
            </div>
        )
    }
}

